import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvUtils } from '@ecm/dispatcher';
import { EcmMaterialModule } from '@ecm/material';
import { LinkService, TrackingData } from '@ecm/router';

import { DashboardAlertsViewModel } from '../../../business/model/home/dashboard/dashboard-alerts.view-model';
import { TrackedPage } from '../../../business/model/tracking/trackedPage.enum';
import { TrackingService } from '../../../services/tracking.service';
import { AdviseWhitelistEclairConstants } from '../../shared/advise-whitelist-eclair.constants';

@Component({
    selector: 'push-alerts[alerts]',
    templateUrl: './push-alerts.component.html',
    styleUrls: ['./push-alerts.component.css'],
    standalone: true,
    imports: [NgTemplateOutlet, EcmMaterialModule],
})
export class PushAlertsComponent implements OnInit {
    public constructor(
        private readonly linkService: LinkService,
        private readonly trackingService: TrackingService,
    ) {}

    @Input()
    public alerts!: DashboardAlertsViewModel[];

    @Input()
    public isMobile: boolean;

    @Input()
    public isSoshBrand: Observable<boolean>;

    protected readonly AdviseWhitelistEclairConstants = AdviseWhitelistEclairConstants;
    public zid!: string;
    public isEclair!: boolean;

    public ngOnInit(): void {
        this.isEclair = EnvUtils.isEclair();
        if (this.alerts) {
            this.alerts?.forEach((alert) => {
                if (alert.link) {
                    alert.href = this.linkService.getLinkSync(alert.link);
                }
                this.zid = this.trackingService.getTrackNamePerType(alert.type, this.isMobile, this.isSoshBrand);
            });
        }
    }

    public openLink(alert: DashboardAlertsViewModel) {
        this.linkService.openLink(
            alert.link,
            Object.assign(new TrackingData(), {
                cappingTracking:
                    alert.advTracker && alert.advTracker.length > 0
                        ? {
                              advTracker: alert.advTracker,
                              code: alert.code,
                              cid: alert.cid,
                          }
                        : null,
                tmsTracking: {
                    trackedPage: TrackedPage.dashboard,
                    trackingArea: 'care_hp_top_alerte',
                    trackingName: alert.code,
                },
            }),
        );
    }
}
